<template>
  <canvas id="renderCanvas" ref="renderCanvas" class="switching-room"></canvas>
</template>
<script>
import * as BABYLON from 'babylonjs';
import td from '@/components/three-dismensional/scripts/td';

export default {
  name: 'switching-room',
  data() {
    return {
      redenerRoom: null,
      roomName: '',
      engine: null,
      scene: null,
    };
  },
  mounted() {
    this.renderDom = this.$refs.renderCanvas;
    this.roomName = this.$route.params.roomName;
    this.renderDiv(this.renderDom, this.roomName);
  },
  beforeRouteLeave(to, from, next) {
    this.stopEngineScene();
    next();
  },
  watch: {
    $route() {
      this.roomName = this.$route.params.roomName;
      this.renderDiv(this.renderDom, this.roomName);
    },
  },
  methods: {
    stopEngineScene() {
      this.scene.dispose();
      this.engine.dispose();
    },
    renderDiv(element, roomName) {
      if (!this.engine) {
        this.engine = new BABYLON.Engine(element, true);
      }
      this.scene = this.getTdClass(roomName).createScene(element, this.engine);
      this.engine.runRenderLoop(() => {
        this.scene.render();
        this.engine.resize();
      });

      window.addEventListener('resize', () => {
        this.engine.resize();
      });
    },
    getTdClass(type) {
      return this.getNoClass(parseInt(type, 10) - 1);
    },
    getNoClass() {
      return td;
    },
  },
};
</script>
<style scoped>
*:focus {
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* mobile webkit */
}
</style>
